module.exports = __webpack_public_path__ + "src/img/tvIconOn.fd08535e.svg";